const SESSION_KEY = 'finizi_session';
const THIRTY_DAYS = 30 * 24 * 60 * 60 * 1000;

export function getFiniziSession() {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    const session = JSON.parse(raw);
    if (!session?.session_expires_at || Date.now() > session.session_expires_at) {
      localStorage.removeItem(SESSION_KEY);
      return null;
    }
    return session;
  } catch {
    return null;
  }
}

export function saveFiniziSession(userData) {
  const session = {
    ...userData,
    session_expires_at: Date.now() + THIRTY_DAYS,
  };
  localStorage.setItem(SESSION_KEY, JSON.stringify(session));
}

export function clearFiniziSession() {
  localStorage.removeItem(SESSION_KEY);
  localStorage.removeItem('webvonk_superadmin');
}
